import { proxy, useSnapshot } from 'valtio';
const eventStore = proxy({
    events: [],
});
const setEvents = (events) => {
    eventStore.events = events;
};
const updateEvents = (updateFn) => {
    const newEvents = updateFn(eventStore.events);
    setEvents(newEvents);
};
export const useEventStore = () => {
    const snapshot = useSnapshot(eventStore);
    return {
        events: snapshot.events,
        setEvents,
        updateEvents,
    };
};
